import { select } from 'redux-saga/effects';

import {
  departments,
  VOX_STATES,
  VOX_INCIDENT_STATUSES,
} from '../../consts/vox';

import dateIsToday from '../../utils/dateIsToday';

import { safeCall } from '../sagas/errors';

const getState = state => state.dialer;

export function* canCallChecker({ operatorStatus, contactNumber }) {
  const { state, operator } = yield select(getState);
  const notMe = contactNumber !== (operator && operator.number);
  const operatorReady = [VOX_STATES.READY, VOX_STATES.ONLINE].includes(
    operatorStatus
  );
  const meReady = ![
    VOX_STATES.IN_SERVICE,
    VOX_STATES.INCOMING,
    VOX_STATES.OUTGOING,
  ].includes(state);

  return notMe && meReady && operatorReady;
}

export function* canTransferChecker({ contactNumber, operatorStatus }) {
  const { state, operator, isTransfering, isInterception } = yield select(
    getState
  );
  const notMe = contactNumber !== (operator && operator.number);
  const meTalking = state === VOX_STATES.IN_SERVICE;
  const operatorReady = [VOX_STATES.READY, VOX_STATES.ONLINE].includes(
    operatorStatus
  );

  return (
    notMe && meTalking && operatorReady && !isTransfering && !isInterception
  );
}

function* canListenChecker({
  operatorStatus,
  isSupervisor: isOperatorSupervisor,
  contactNumber,
}) {
  const { state, isSupervisor } = yield select(getState);
  const meTalking = state === VOX_STATES.IN_SERVICE;
  const operatorTalking = operatorStatus === VOX_STATES.IN_SERVICE;
  const hasClientNumber =
    contactNumber && contactNumber !== 'прямой звонок на внутренний номер';
  return (
    isSupervisor &&
    operatorTalking &&
    !meTalking &&
    hasClientNumber &&
    !isOperatorSupervisor
  );
}

export function* canRequestHelpChecker({
  operatorStatus,
  isSupervisor: isOperatorSupervisor,
}) {
  const { state, isSupervisor, isTransfering, isInterception } = yield select(
    getState
  );
  const operatorReady = [VOX_STATES.READY, VOX_STATES.ONLINE].includes(
    operatorStatus
  );
  const meTalking = state === VOX_STATES.IN_SERVICE;
  const isPermited = !isSupervisor && isOperatorSupervisor;

  return (
    isPermited &&
    meTalking &&
    operatorReady &&
    !isTransfering &&
    !isInterception
  );
}

export function* parseOperator(
  {
    client_name: contactName,
    client_phone: contactNumber,
    state,
    full_name: name,
    id,
    pbx_id: pbxId,
    sip_extension: number,
    skill_groups: skillGroups,
    call_duration: callDuration,
    is_supervisor: isSupervisor,
    is_call_center_operator: isCallCenter,
  },
  { id: currentOperatorId, operatorStatus: currentOperatorStatus }
) {
  const operatorStatus =
    id === currentOperatorId ? currentOperatorStatus : state;
  const canCall = yield safeCall(canCallChecker, {
    contactNumber,
    operatorStatus,
  });
  const canTransfer = yield safeCall(canTransferChecker, { operatorStatus });
  const canListen = yield safeCall(canListenChecker, {
    contactNumber,
    operatorStatus,
    isSupervisor,
  });
  const canRequestHelp = yield safeCall(canRequestHelpChecker, {
    operatorStatus,
    isSupervisor,
  });
  return {
    call: {
      id,
      pbxId,
      duration: callDuration,
    },
    contact: contactNumber && {
      name: contactName,
      number: contactNumber,
      isHidden: isSupervisor,
    },
    operator: {
      name,
      number,
      state: operatorStatus,
      skillGroups,
      isCallCenter,
      canCall,
      canTransfer,
      canListen,
      canRequestHelp,
    },
  };
}

export function parseDepartment({ id, name_ru: value, name_en: nameEN }) {
  const department = departments[nameEN] || departments.CallCenterQueue;

  return {
    id,
    svg: department.svg,
    isReserve: !!department.isReserve,
    value,
  };
}

export function parseCall({ fullname: name, phone: number }) {
  return {
    name,
    number,
  };
}

export function serializeVoxIncidentStatusForToday(errors) {
  if (!errors && errors.length <= 0) return VOX_INCIDENT_STATUSES.GOOD;

  const [latestIncident] = errors;
  const { published: publishDate, description } = latestIncident;

  if (!dateIsToday(publishDate)) return VOX_INCIDENT_STATUSES.GOOD;

  const regex = /<strong>(.*?)<\/strong>/s;
  const [, status] = regex.exec(description);

  return status === VOX_INCIDENT_STATUSES.RESOLVED
    ? VOX_INCIDENT_STATUSES.RESOLVED
    : VOX_INCIDENT_STATUSES.INVESTIGATING;
}
